import { CopyAll, FileDownload } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

import { useTheme } from "@mui/styles";

export const ShareTypeCurve = ({ darkMode, setShareTypeCurveVisible, handleExportTypeCurveJSONClick, handleCopyTypeCurveLink }) => {
  
  const theme = useTheme();

  return (
    <Dialog 
      open={true} 
      onClose={() => setShareTypeCurveVisible(false)}
      fullWidth={true}
      maxWidth="xs"
      PaperProps={{
        style: {
          backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']
        },
      }}
      elevation={0}
    >
      <DialogTitle id="form-dialog-title">Share Type Curve</DialogTitle>
      <DialogContent>
        <Typography style={{marginBottom: 10}}>Copy type curve share link</Typography>
        <Button fullWidth onClick={handleCopyTypeCurveLink} color={darkMode ? "inherit" : "primary"}
          style={{color: darkMode ? '#000' : '#fff'}} variant="contained" startIcon={<CopyAll />}
        >
          Copy Link
        </Button>

        <Typography style={{marginTop: 40, marginBottom: 10}}>Export type curve JSON</Typography>
        <Button fullWidth onClick={handleExportTypeCurveJSONClick} color={darkMode ? "inherit" : "primary"}
          style={{color: darkMode ? '#000' : '#fff'}} variant="contained" startIcon={<FileDownload />}
        >
          Export JSON
        </Button>

        
      </DialogContent>
      <DialogActions style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button onClick={() => setShareTypeCurveVisible(false)} color={darkMode ? "inherit" : "primary"}
          style={{color: darkMode ? '#000' : '#fff'}} variant="contained"
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS
  
};